import { GRAMMAR_SESSION_OUTCOMES } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { grammarUserStateSchema } from '../schemas';

const grammarGradedResultSchema = z.object({
  itemId: z.number().int(),
  correct: z.boolean(),
});

const grammarPointOutcomeSchema = z.object({
  pointId: z.number().int(),
  score: z.number(),
  outcome: z.enum(GRAMMAR_SESSION_OUTCOMES),
});

const saveGrammarSessionV2DataSchemaDefinition = z.object({
  graded: z.array(grammarGradedResultSchema),
  outcomes: z.array(grammarPointOutcomeSchema),
  states: z.array(grammarUserStateSchema),
  pointsEarned: z.number().int(),
  currentStreak: z.number().int(),
});

export const saveGrammarSessionV2DataSchema: typeof saveGrammarSessionV2DataSchemaDefinition =
  saveGrammarSessionV2DataSchemaDefinition;

export type ISaveGrammarSessionV2Data = z.infer<typeof saveGrammarSessionV2DataSchema>;

export const saveGrammarSessionV2ResponseSchema: z.ZodSchema<IAPI<ISaveGrammarSessionV2Data>> =
  createApiResponseSchema(saveGrammarSessionV2DataSchema) as z.ZodSchema<
    IAPI<ISaveGrammarSessionV2Data>
  >;

export type ISaveGrammarSessionV2Response = IAPI<ISaveGrammarSessionV2Data>;
